<script setup lang="ts">
import type { AbstractData } from '~/utils/solr/journal-utils'

defineProps<{
  data: AbstractData
}>()

const open = defineModel<boolean>('open', { default: false })
</script>

<template>
  <div>
    <section
      id="abstract-content"
      :class="open ? 'max-h-fit after:!bg-none pb-xl' : 'max-h-[118px]'"
      class="
        bg-blue-50
        dark:bg-carbon-500
        rounded-lg
        pt-2xs
        px-m
        flex
        flex-col
        gap-2.5
        overflow-hidden
        relative
        transition-[max-height]
        duration-500
        text-carbon-500
        dark:text-carbon-50
        font-body
        after:bg-gradient-to-b
        after:from-transparent
        after:to-blue-50
        dark:after:to-carbon-500
      "
    >
      <h2 class="text-small font-bold" v-text="data.title" />
      <p class="text-xsmall" :class="{ '-mt-2xs': !open }" v-text="data.abstractText" />
    </section>
    <Button
      class="mx-auto -translate-y-1/2 text-sm font-medium"
      :aria-expanded="open"
      aria-controls="abstract-content"
      color="blurple"
      size="small"
      variant="primary"
      @click="open = !open"
    >
      {{ open ? 'Skjul' : 'Se' }} sammendrag
    </Button>
  </div>
</template>

<style scoped lang="postcss">
section::after {
  @apply z-0 content-[''] absolute inset-0 top-auto h-24 pointer-events-none;
}
</style>
